import { render, staticRenderFns } from "./BlockEditor.vue?vue&type=template&id=76dd66be&"
import script from "./BlockEditor.vue?vue&type=script&lang=ts&"
export * from "./BlockEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BlockEditor.vue?vue&type=style&index=0&id=76dd66be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports